<div class="dialog-wrapper">
  <!-- Header -->
  <div class="dialog-header">
    <button class="close-btn" (click)="onClose()" type="button">
      <span>&times;</span>
    </button>
    <h2 class="dialog-title">Used Invitations</h2>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <!-- Table -->
    <div class="table-wrapper">
      <table class="data-table">
        <thead>
          <tr>
            <th>Invitation Date</th>
            <th>Customer Name</th>
            <th>Number</th>
            <th>National ID</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let invitation of invitations">
            <td>{{ invitation.invitationDate }}</td>
            <td>{{ invitation.customerName }}</td>
            <td>{{ invitation.number }}</td>
            <td>{{ invitation.nationalId }}</td>
          </tr>
          <tr *ngIf="invitations.length === 0">
            <td colspan="4" class="empty-cell">No invitations used yet</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="btn btn-close" (click)="onClose()" type="button">
      Close
    </button>
  </div>
</div>
